// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7775) return "css/Template2.a314cab6-674b-4aee-bc98-e8da23bbcecc.chunk.css";
	if (chunkId === 628) return "css/Template3.a314cab6-674b-4aee-bc98-e8da23bbcecc.chunk.css";
	if (chunkId === 9245) return "css/MobileTemplate1.a314cab6-674b-4aee-bc98-e8da23bbcecc.chunk.css";
	if (chunkId === 7866) return "css/aiAgent.a314cab6-674b-4aee-bc98-e8da23bbcecc.chunk.css";
	if (chunkId === 1399) return "packages/reactflow@11.8.3/reactflow.a314cab6-674b-4aee-bc98-e8da23bbcecc.bundle.css";
	if (chunkId === 4149) return "packages/@wangeditor@5.0.1/@wangeditor.a314cab6-674b-4aee-bc98-e8da23bbcecc.bundle.css";
	if (chunkId === 3339) return "packages/icp-mining@2.0.56/icp-mining.a314cab6-674b-4aee-bc98-e8da23bbcecc.bundle.css";
	if (chunkId === 8309) return "css/saas-ui-chat.a314cab6-674b-4aee-bc98-e8da23bbcecc.chunk.css";
	if (chunkId === 5299) return "packages/icp-form-designer@2.0.56/icp-form-designer.a314cab6-674b-4aee-bc98-e8da23bbcecc.bundle.css";
	// return url for filenames based on template
	return undefined;
};